/**
 * NoAccess: shown when a signed-in user opens a route they lack the module key for.
 * Replaces a silent redirect to Home, which left users with no idea why the page
 * never opened and nothing specific to report to an administrator.
 * Names the module and the exact permission key so the user can ask for it.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from './PageHeader';
import { PERMISSIONS } from '../config/permissions';

const NoAccess = ({ moduleLabel, requiredPermission }) => {
  const isAdminOnly = requiredPermission === PERMISSIONS.ADMIN;

  return (
    <div style={{ maxWidth: '700px', margin: '0 auto', padding: '0 1rem 6rem 1rem' }}>
      <PageHeader title="You don't have access" backTo="/" backLabel="← Home" />

      <div
        style={{
          background: 'var(--cr-bg-warm)',
          border: '1px solid var(--cr-border)',
          borderRadius: '10px',
          padding: '1.25rem',
        }}
      >
        <p style={{ margin: 0, fontWeight: 500 }}>
          {moduleLabel
            ? <>Your account doesn&apos;t have access to <strong>{moduleLabel}</strong>.</>
            : <>Your account doesn&apos;t have access to this page.</>}
        </p>

        <p style={{ margin: '0.75rem 0 0', color: 'var(--cr-text-muted)', fontSize: '0.95rem' }}>
          {isAdminOnly ? (
            <>This page is limited to portal administrators. If you think you should have it, ask an administrator.</>
          ) : (
            <>
              You&apos;re signed in correctly — you just haven&apos;t been given this module yet. Ask a
              portal administrator to add the{' '}
              <code
                style={{
                  background: 'var(--cr-border)',
                  borderRadius: '4px',
                  padding: '0.1rem 0.35rem',
                  fontSize: '0.9em',
                }}
              >
                {requiredPermission}
              </code>{' '}
              key to your access.
            </>
          )}
        </p>
      </div>

      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/">← Back to Home</Link>
      </p>
    </div>
  );
};

export default NoAccess;
